<template>
  <check-permission :entity-type="entityType" :permissions="permissions" :entity-id="entityId">
    <tooltip :text="label">
      <button
        class="btn btn-light btn-icon rounded-circle hover-effect-dot waves-effect waves-themed mr-2 mb-2"
        :aria-label="label"
        @click.stop="$emit('pressed', data)"
      >
        <i :style="{ color: event.color }" :class="event.icon" />
      </button>
    </tooltip>
  </check-permission>
</template>

<script>
import Tooltip from '@/components/tooltip/Tooltip';

// @vuese
// Okrągły przycisk
// @group helpers
export default {
  components: { Tooltip },
  props: {
    // Typ encji
    entityType: {
      type: String,
      required: false
    },
    // Nazwa uprawnień
    permissions: {
      type: String,
      required: true
    },
    // Id encji
    entityId: {
      type: Number,
      required: false
    },
    // Zdarzenie z enuma posiadające kolor i ikonkę
    event: {
      type: Object,
      required: true
    },
    // Obiekt do emita
    data: {
      type: Object,
      required: true
    },
    // Opis przycisku
    label: {
      type: String,
      required: true
    }
  }
};
</script>
